import { LIMITE_ASSUNTO, LIMITE_ASSUNTO_CELULAR, medirAssunto, type FaixaAssunto } from '../entrega';

/**
 * Contagem de caracteres do assunto com as DUAS marcas que importam: onde o
 * celular corta (40) e onde o computador corta (60).
 *
 * A barra tem as duas marcas desenhadas e o texto diz a consequencia ("corta
 * no celular"), nao so o numero. `aria-live` educado: o leitor de tela ouve a
 * faixa quando ela muda, nao a cada tecla.
 */

const TOM: Readonly<Record<FaixaAssunto, { readonly barra: string; readonly texto: string; readonly frase: string }>> = {
  vazio: { barra: 'bg-ink-subtle', texto: 'text-ink-subtle', frase: 'Escreva o assunto.' },
  ideal: { barra: 'bg-status-good', texto: 'text-status-good', frase: 'Cabe inteiro no celular.' },
  longo: { barra: 'bg-status-warning', texto: 'text-status-warning', frase: 'Corta no celular; cabe no computador.' },
  cortado: { barra: 'bg-status-critical', texto: 'text-status-critical', frase: 'Corta até no computador.' },
};

export function MedidorDeCaracteres({ texto, id }: { readonly texto: string; readonly id?: string }): JSX.Element {
  const { caracteres, faixa } = medirAssunto(texto);
  const tom = TOM[faixa];
  const escala = LIMITE_ASSUNTO + 20;
  const largura = Math.min(100, Math.round((caracteres * 100) / escala));
  return (
    <div id={id} className="flex flex-col gap-1">
      <div className="relative h-1.5 w-full overflow-hidden rounded-full bg-ink/10" aria-hidden="true">
        <div className={`h-full rounded-full transition-[width] ${tom.barra}`} style={{ width: `${largura}%` }} />
        <span className="absolute inset-y-0 w-px bg-ink/40" style={{ left: `${Math.round((LIMITE_ASSUNTO_CELULAR * 100) / escala)}%` }} />
        <span className="absolute inset-y-0 w-px bg-ink/40" style={{ left: `${Math.round((LIMITE_ASSUNTO * 100) / escala)}%` }} />
      </div>
      <p className="flex flex-wrap justify-between gap-2 text-xs">
        <span aria-live="polite" className={tom.texto}>
          {tom.frase}
        </span>
        <span className="tabular-nums text-ink-subtle">
          {caracteres} caracteres · celular até {LIMITE_ASSUNTO_CELULAR}, computador até {LIMITE_ASSUNTO}
        </span>
      </p>
    </div>
  );
}
